module.exports = __webpack_public_path__ + "sunsemweb/img/fb_.06cac9e1.svg";